module.exports = "/assets/kropla@2x.png?2Osa9dA";